import React from "react";
import { Link } from "react-router-dom";

import { Body, SubTitle } from "src/components/typography/typography";
import { MINIMUM_THRESHOLDS } from "src/utils/minimum_thresholds";
import { Routes } from "src/utils/routes";

/*
 * Constants
 */

const GROUP_LABELS: [ConstituencyGroup, string][] = [
    ["students", "Students"],
    ["teachers", "Teachers"],
    ["administrators", "Administrators"],
    ["supportStaff", "Support Staff"],
    ["parents", "Parents"],
    ["alumni", "Alumni"],
    ["boardMembers", "Board Members"],
];

/*
 * Main
 */

export const SurveyStatusHelp = (): React.ReactElement => (
    <>
        <Body>
            The numerator represents the number of surveys received and the denominator represents the minimum number
            needed to run a report: the number entered for the constituent group multiplied by its minimum threshold
            below. Once the numerator has met the minimum threshold to run a report, it will state 100%, but this does
            not mean that 100% of your surveys have been submitted. The report can only be run once, so please be
            certain that you have collected the number of responses you want. The constituent group counts can be
            adjusted at any time on the <Link to={Routes.constituentGroups}>Constituent Groups</Link> page.
        </Body>
        <SubTitle>Minimum Threshold</SubTitle>
        <table className="threshold-table">
            <tbody>
                {GROUP_LABELS.map(([group, label]) => (
                    <tr key={group}>
                        <td>{label}</td>
                        <td>{Math.round(MINIMUM_THRESHOLDS[group] * 100)}%</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </>
);
